import UserReportAnalytics from './userReports/UserReportAnalytics'

/**
 * Registry mapping report types to their respective analytics components and metadata.
 * Extensible for future report types (e.g. flight_audit, rebooking, recovery, etc.)
 */
const analyticsRegistry = {
  users: {
    title: 'User Report Analytics',
    description: 'Detailed user engagement and module access analytics',
    component: UserReportAnalytics,
  },
  // Future extensions:
  // flight_audit: {
  //   title: 'Flight Audit Analytics',
  //   component: FlightAuditAnalytics,
  // },
  // rebooking: {
  //   title: 'Rebooking Analytics',
  //   component: RebookingAnalytics,
  // },
}

/**
 * Helper to get registered analytics by report type
 * @param {string} type
 * @returns {Object|null}
 */
export const getAnalyticsForType = (type) => {
  if (!type) return null
  return analyticsRegistry[type] || null
}

/**
 * Allows runtime dynamic registration of additional analytics modules
 * @param {string} type
 * @param {Object} config
 */
export const registerAnalytics = (type, config) => {
  if (type && config) {
    analyticsRegistry[type] = config
  }
}

/**
 * Checks if a report type has registered analytics
 * @param {string} type
 * @returns {boolean}
 */
export const hasAnalyticsForType = (type) => {
  return Boolean(type && analyticsRegistry[type])
}

export default analyticsRegistry
